<template>
  <div class="teaser-home">
    <div class="content">
      <h2 v-if="data.title" class="title" v-html="data.title" />
      <StructuredText
        v-if="data.lead"
        class="structured-text text-md-xs text-md-sm text-lg-md text-lg-lg lead"
        :data="data.lead"
      />
    </div>
    <Link v-if="data.link" :link="data.link" class="button-primary button" icon-position="left" />
  </div>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import type { TeaserHomeFragment } from '#gql';
import Link from '~/components/content-modules/components/Link.vue';

defineProps<{
  data: TeaserHomeFragment;
}>();
</script>

<style scoped lang="scss">
.teaser-home {
  background-color: var(--color-main-blue-light);
  color: var(--color-main-blue);
  padding: var(--spacing-md) var(--spacing-xs) var(--spacing-sm);
  min-height: 32.5rem;
  height: 100%;
  display: grid;
  align-content: space-between;
  justify-items: start;

  @media (--xs), (--sm) {
    height: 100%;
    min-height: 17rem;
    padding: var(--spacing-2xs);
  }

  > .content > .lead {
    @media (--xs), (--sm) {
      margin: var(--spacing-3xs) 0 calc(2 * var(--spacing-3xs));
    }

    @media (--md), (--lg) {
      margin: var(--spacing-2xs) 0 calc(2 * var(--spacing-2xs));
    }
  }
}
</style>
